import { Box } from '@mantine/core';
import { useGetColor } from '../hooks';
import type { IconPropsType } from './types';

export const UndoIcon = ({ size = 24, sx, color, ...props }: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.9985 14.0806C19.6103 9.5295 14.7955 6.96545 10.2444 8.35367C7.61801 9.15478 5.6534 11.097 4.72818 13.4711M3.00148 9.91958L4.25828 14.0399L8.37855 12.7831"
        stroke={iconColor}
        strokeWidth="1.5"
      />
    </Box>
  );
};
